"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styling_1 = require("@uifabric/styling");
var utilities_1 = require("@uifabric/utilities");
var getClassNames = utilities_1.memoizeFunction(function (styles, className) {
    return {
        root: styling_1.mergeStyles("error", className, styles.root),
        compact: styling_1.mergeStyles("compact-error", className, styles.compact),
        message: styling_1.mergeStyles("error-message", styles.message),
        item: styling_1.mergeStyles("error-item", styles.item),
        itemTitle: styling_1.mergeStyles("error-item-title", styles.itemTitle),
        itemValue: styling_1.mergeStyles("error-item-value", styles.itemValue)
    };
});
exports.getClassNames = getClassNames;
